var map = {
	"./algas-marinhas.jpg": 526,
	"./aquarela.png": 28181,
	"./bg-algas-marinhas.png": 55798,
	"./bg-aquarela.png": 39607,
	"./bg-classico.png": 95428,
	"./bg-conchas-no-oceano.png": 89773,
	"./bg-floral-clean.png": 13547,
	"./bg-floral-ellegance.png": 23257,
	"./bg-floral-maritimo.png": 88987,
	"./bg-floral-night.png": 67930,
	"./bg-floral-rustico.png": 36656,
	"./bg-florani.png": 91456,
	"./bg-moderno.png": 67200,
	"./bg-pintura.png": 31698,
	"./bg-por-do-sol.png": 10923,
	"./bg-romantico.png": 94087,
	"./bg-rustico.png": 46734,
	"./classico.png": 14034,
	"./conchas-no-oceano.jpg": 20646,
	"./floral-clean.png": 54565,
	"./floral-ellegance.png": 22869,
	"./floral-maritimo.png": 51831,
	"./floral-night.png": 95434,
	"./floral-rustic.png": 55347,
	"./florani.png": 57335,
	"./moderno.png": 85187,
	"./pintura.png": 45878,
	"./por-do-sol.jpg": 74704,
	"./romantico.png": 17808,
	"./rustico.png": 15592
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 77434;